import { HomeStates } from "./HomeStates";
import { NavigationStates } from "./NavigationStates";

export const Contexts = () => {
    return {
        navigation_state: NavigationStates(),
        home_state: HomeStates()
    }
}